var data = {
  "body": "<path d=\"M12.499 7.5c-5.185-.471-8.518 1.529-9.999 6c2.895-3.22 6.229-3.886 10-2v-.002V14.5l5-5l-5-5z\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "width": 21,
  "height": 21
};
export default data;